import styled from 'styled-components';
import { IModalPortal, ModalPosition } from '.';
import { MdClose } from 'react-icons/md';

const Content = styled.div<{ position?: ModalPosition }>`
    background: #00000012;
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99999999;
`;

const ModalPortal = styled.div<IModalPortal>`
    position: fixed;
    background: #fff;

    ${(props) =>
        (!props.position || props.position === ModalPosition.center) &&
        `
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    `}

    ${(props) =>
        props.position === ModalPosition.topCenter &&
        `
        transform: translate(-50%, -50%);
        left: 50%;
    `}

    width: ${(props) => props.width || '240px'};

    ${(props) =>
        props.position === ModalPosition.fullRight &&
        `
        right: 0;
        height: ${props.height || '100vh'}; 
    `}

    ${(props) =>
        props.position === ModalPosition.fullLeft &&
        `
        left: 0;
        height: ${props.height || '100vh'}; 
    `}
`;

const ContentModal = styled.div`
    padding: 15px;
    background: #fff;
`;

const DefaultHeader = styled.div`
    display: flex;
    justify-content: space-between;
    flex: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #fff;
        margin: 0 5px;
    }
`;

const CloseIcon = styled(MdClose)`
    width: 20px !important;
    min-width: 20px !important;
    height: 20px !important;
    cursor: pointer;
    color: #fff;
`;

const ActionArea = styled.div<{ withHeader: boolean }>`
    display: flex;
    ${(props) =>
        !props.withHeader &&
        `
        justify-content: flex-end;
        align-items: center;
    `}
    height: 48px;
    padding: 0 10px;
    background: #47516f;
`;

const ModalConfirmContainer = styled('div')``;

const ModalConfirmBtnContainer = styled('div')`
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
`;

export {
    Content,
    ModalPortal,
    CloseIcon,
    ActionArea,
    ContentModal,
    ModalConfirmBtnContainer,
    ModalConfirmContainer,
    DefaultHeader,
};
